import { useEffect, useState } from "react"

import { useForm, useStepTransition } from "@garantidos/hooks"
import { httpRequests, proposalHttpController } from "@garantidos/services"
import { getItem } from "@garantidos/utils"

import isMobile from "@mobi/utils/browser/isMobile"

import validatorsDictionary from "pages/Proposal/hooks/validators"

import useSoftleadOneClick from "../../hooks"

import { ProposalContext, useProposalContext } from "contexts/proposal"

import { fields } from "../../fields"
import * as trackers from "../../trackings"

const useName = () => {
  const { hashDocument } = httpRequests
  const { setTrackingBackHome } = useSoftleadOneClick()
  const [isLoadingPage, setIsLoadingPage] = useState(true)
  const [hasCpfFromHero, setHasCpfFromHero] = useState(!!getItem("cpfFromHero"))
  const [cpfFromHero, setCpfFromHero] = useState(getItem("cpfFromHero"))
  const { form } = useForm({
    fields,
    context: ProposalContext,
    validatorsDictionary
  })

  const { setValue } = form

  const {
    cpfData,
    errorMessage,
    setErrorMessage,
    isLoading,
    updateStepInfo,
    setIsStepVisible,
    updateCpfData,
    updateProposalData
  } = useProposalContext()

  const { stepNavigator } = useStepTransition(setIsStepVisible)

  const { hashedCpf } = cpfData

  const currentStep = "softlead-simulation-name"
  const nextStep = "softlead-simulation-email"
  const prevStep = "softlead-simulation-cpf"

  const handleCpfFromHero = async () => {
    setHasCpfFromHero(!!cpfFromHero)

    const hashedCpfFromHero = await hashDocument(cpfFromHero)

    setValue("proponent_document", cpfFromHero, {
      shouldValidate: true,
      shouldTouch: true
    })

    updateProposalData({ payload: { proponent_document: cpfFromHero } })
    updateCpfData({ cpf: cpfFromHero, hashedCpf: hashedCpfFromHero })
  }

  useEffect(() => {
    if (!hashedCpf) {
      handleCpfFromHero()
      setIsLoadingPage(false)
      trackers.simulationStarted()
    } else {
      setIsLoadingPage(false)
    }
    trackers.pageview(hashedCpf, "nome")
    setTrackingBackHome("cpf")
  }, [])

  const onSubmitCallback = () => {
    if (isLoading) return

    updateStepInfo({
      current_step: nextStep,
      previous_step: currentStep,
      next_step: nextStep
    })
    stepNavigator("next", nextStep)
    trackers.advance(hashedCpf, "nome")
  }

  const handlePrevStep = () => {
    updateStepInfo({
      current_step: prevStep,
      previous_step: prevStep,
      next_step: currentStep
    })
    stepNavigator("prev", prevStep)
    trackers.back(hashedCpf, "nome")
  }

  return {
    onSubmitCallback,
    handlePrevStep,
    fields,
    form,
    errorMessage,
    setErrorMessage,
    isLoading,
    isLoadingPage,
    hasCpfFromHero
  }
}

export default useName
